import { useCallback } from 'react';

const useScrollToElementById = () => {
  const scrollToElement = useCallback((elementId, bannerClass) => {
    setTimeout(() => {
      const element = document.getElementById(elementId);
      const isBanner = document.getElementsByClassName(bannerClass);
      const offset = isBanner.length > 0 ? 40 : 0;
      if (element) {
        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: elementPosition - offset,
          behavior: 'smooth',
        });
      }
      // 300ms: allows two render cycles for the section to expand before scrolling
    }, 300);
  }, []);
  return scrollToElement;
};

export default useScrollToElementById;
